import { PortalPartnerTypeEnum } from '@escapenavigator/types/dist/partners-portal/enum/portal-partner-type.enum';
import { Badge, Button, Card, Group, Stack, Text, TextInput } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';

import { api } from '../api';
import { apiErrorMessage } from '../api/client';
import { PageHeader } from '../components/page-header';
import { t } from '../dictionary';
import { useAuth } from '../providers/auth-context';

export const SettingsPage = () => {
    const { partner, setPartner } = useAuth();
    const isAuthor = partner.type === PortalPartnerTypeEnum.AUTHOR;

    const [name, setName] = useState(partner.name);
    const [companyName, setCompanyName] = useState(partner.companyName ?? '');
    const [saving, setSaving] = useState(false);

    const save = async () => {
        setSaving(true);

        try {
            const { data } = await api.updateMe({
                name,
                companyName: isAuthor ? undefined : companyName,
            });

            setPartner(data);
            notifications.show({ color: 'green', message: t.common.saved });
        } catch (error) {
            notifications.show({ color: 'red', message: apiErrorMessage(error) });
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <PageHeader title={t.settings.title} />

            <Card padding='lg' maw={520}>
                <Stack gap='md'>
                    <Group justify='space-between'>
                        <Text fw={650}>{t.settings.profile}</Text>
                        <Badge variant='light' color='indigo'>
                            {isAuthor ? t.settings.author : t.settings.venue}
                        </Badge>
                    </Group>

                    <TextInput
                        label={t.auth.fullName}
                        value={name}
                        onChange={(e) => setName(e.currentTarget.value)}
                    />

                    {!isAuthor && (
                        <TextInput
                            label={t.auth.companyName}
                            value={companyName}
                            onChange={(e) => setCompanyName(e.currentTarget.value)}
                        />
                    )}

                    <TextInput
                        label={t.settings.email}
                        value={partner.email}
                        disabled
                        description={t.settings.emailNote}
                    />

                    <Group justify='flex-end'>
                        <Button loading={saving} onClick={save}>
                            {t.common.save}
                        </Button>
                    </Group>
                </Stack>
            </Card>
        </>
    );
};
